"use client";
import React, { useRef } from "react";
import useBuilder from "../hooks/useBuilder";
import { cn } from "@pulsex/utils";
import { ArrowUp, ArrowDown, Edit2, Trash2 } from "lucide-react"; // Changed import to lucide-react
import { Button } from "./ui/button";
import { Drawer, DrawerClose, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger, } from "./ui/drawer";
import EditBlockForm from "./EditBlockForm";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger, } from "./ui/dialog";
export default function EditableBlock({ config, block, children, }) {
    const ref = useRef(null);
    const widget = block.getMainWidget();
    const { setSelectedWidget, selectedWidget, handleMoveUp, handleMoveDown, handleDeleteBlock, blockOrder } = useBuilder({
        config,
    });
    const handleClick = () => {
        if (!widget)
            return;
        setSelectedWidget(widget);
    };
    const isSelected = (selectedWidget === null || selectedWidget === void 0 ? void 0 : selectedWidget.code) === (widget === null || widget === void 0 ? void 0 : widget.code);
    return (React.createElement("div", { ref: ref, onClick: handleClick, className: cn("border-2 border-transparent hover:bg-[#F3F3F3]/10", isSelected &&
            "border-sky-500 relative hover:border-sky-500 bg-[#F3F3F3]/20 hover:bg-[#F3F3F3]/20") },
        isSelected && (React.createElement("div", { className: "flex flex-col top-5 left-5 absolute border shadow-xl bg-[#F3F3F3] rounded-md p-1 z-[9999] animate-in-slide" },
            React.createElement(Button, { variant: "ghost", size: "icon", onClick: (e) => {
                    e.stopPropagation();
                    handleMoveUp(block.uniqueId);
                }, disabled: blockOrder.indexOf(block.uniqueId) === 0 },
                React.createElement(ArrowUp, { className: "w-4 h-4 text-black/80" })),
            React.createElement(Button, { variant: "ghost", size: "icon", onClick: (e) => {
                    e.stopPropagation();
                    handleMoveDown(block.uniqueId);
                }, disabled: blockOrder.indexOf(block.uniqueId) === blockOrder.length - 1 },
                React.createElement(ArrowDown, { className: "w-4 h-4 text-black/80" })),
            React.createElement(Drawer, null,
                React.createElement(DrawerTrigger, { asChild: true },
                    React.createElement(Button, { variant: "ghost", size: "icon" },
                        React.createElement(Edit2, { className: "w-4 h-4 text-black/80" }))),
                React.createElement(DrawerContent, { className: "px-0" },
                    React.createElement("div", { className: "container mx-auto w-full" },
                        React.createElement(DrawerHeader, { className: "px-0" },
                            React.createElement(DrawerTitle, null,
                                "Edit widget: ", widget === null || widget === void 0 ? void 0 :
                                widget.code)),
                        React.createElement(EditBlockForm, { block: block }),
                        React.createElement(DrawerFooter, { className: "flex flex-row items-center justify-end gap-2 px-0" },
                            React.createElement(Button, null, "Save"),
                            React.createElement(DrawerClose, { asChild: true },
                                React.createElement(Button, { variant: "outline" }, "Cancel")))))),
            React.createElement(Dialog, null,
                React.createElement(DialogTrigger, { asChild: true },
                    React.createElement(Button, { variant: "ghost", size: "icon", className: "hover:bg-red-500/10" },
                        React.createElement(Trash2, { className: "w-4 h-4 text-red-600/80" }))),
                React.createElement(DialogContent, null,
                    React.createElement(DialogHeader, null,
                        React.createElement(DialogTitle, null, "Confirm Deletion"),
                        React.createElement(DialogDescription, null,
                            "Are you sure you want to delete widget ", widget === null || widget === void 0 ? void 0 :
                            widget.code,
                            "?")),
                    React.createElement(DialogFooter, null,
                        React.createElement(DialogClose, { asChild: true },
                            React.createElement(Button, { variant: "outline" }, "Cancel")),
                        React.createElement(Button, { className: "bg-red-500 hover:bg-red-600 text-white", onClick: () => {
                                handleDeleteBlock(block.uniqueId);
                            } }, "Delete")))))),
        children));
}
